import { render, staticRenderFns } from "./ProjectPrint.vue?vue&type=template&id=1a463ee4&scoped=true"
import script from "./ProjectPrint.vue?vue&type=script&lang=js"
export * from "./ProjectPrint.vue?vue&type=script&lang=js"
import style0 from "./ProjectPrint.vue?vue&type=style&index=0&id=1a463ee4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a463ee4",
  null
  
)

export default component.exports